import React, { useState, useRef } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import showToast from "../helpers/showToast";
import { post, get } from "../server";
import { loggedInUser, isOwnerPackage, accountType } from "../utils/store";
import { TRANSACTION, GET_USER } from "../utils/constants/apiUrl";
import { useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import Form from "react-bootstrap/Form";
import useFunctionsCount from "../hooks/useFunctionsCount";
import { trackEvent } from "../utils/mixpanel";
import { Button } from "react-bootstrap";

const cardElementOptions = {
  hidePostalCode: true,
  style: {
    base: {
      iconColor: "#000000",
      fontSize: "14px",
      color: "#000000",
      background: "#ffffff",

      "::placeholder": {
        color: "#000000",
      },
    },
    invalid: {
      color: "#ff0000",
    },
  },
};

const CheckoutForm = ({
  handleCloseModal,
  selectedPackage,
  selectedSubscriptionType,
  couponData,
}) => {
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [isOwnerPackageActive, setIsOwnerPackageActive] =
    useAtom(isOwnerPackage);
  const [personalAccount, setPersonalAccount] = useAtom(accountType);
  const [isChecked, setIsChecked] = useState(false);
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  let navigate = useNavigate();
  const checkbox = useRef();
  const { userActions } = useFunctionsCount();
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (selectedPackage.id === 1 && !isChecked) {
      setError("Please confirm the downgrade by checking the checkbox.");
      return;
    }

    if (!stripe || !elements) {
      return;
    }
    setIsLoading(true);
    const cardElement = elements.getElement(CardElement);

    try {
      // const { error: stripeError, token } = await stripe.createToken(
      //   cardElement
      // );

      // if (stripeError) {
      //   setIsLoading(false);
      //   showToast(false, stripeError.message);
      //   return;
      // }
      let stripeToken = null;
      if (
        selectedPackage.id !== 1 &&
        couponData?.package_price_after_discount !== 0
      ) {
        const { error: stripeError, token } = await stripe.createToken(
          cardElement
        );
        if (stripeError) {
          setIsLoading(false);
          showToast(false, stripeError.message);
          return;
        }
        stripeToken = token.id; // Assign token ID
      }
      // const amount =
      //   selectedSubscriptionType === "monthly"
      //     ? selectedPackage?.price_monthly
      //     : selectedPackage?.price_yearly;
      let originalAmount =
        selectedSubscriptionType === "monthly"
          ? selectedPackage?.price_monthly
          : selectedSubscriptionType === "yearly"
          ? selectedPackage?.price_yearly
          : selectedPackage.price;
      let amount =
        selectedSubscriptionType === "monthly" || selectedPackage.id === 5
          ? selectedPackage?.price_monthly
          : selectedSubscriptionType === "yearly"
          ? selectedPackage?.price_yearly
          : selectedPackage.price;
      let couponCode = null;
      let couponCodeId = null;
      let discount = 0;
      let discountAmount = 0;
      if (couponData && couponData.coupons_applied_status) {
        couponCode = couponData?.coupon_code;
        couponCodeId = couponData?.coupon_code_id;
        discount = couponData?.discount_percentage;
        discountAmount = couponData?.discount_amt;
        amount = couponData?.package_price_after_discount;
        originalAmount = couponData?.package_price;
      }

      let paymentObj = {
        stripe_token: stripeToken,
        amount: amount,
        auto_renew: checkbox.current.checked ? true : false,
        duration: selectedPackage?.duration,
        package_id: selectedPackage?.id,
        coupon_code: couponCode,
        coupon_code_id: couponCodeId,
        discount: discount,
        discount_amount: discountAmount,
        original_amount: originalAmount,
        subscription_type: selectedSubscriptionType,
      };

      if (amount === 0) {
        paymentObj = {
          amount: amount,
          auto_renew: checkbox.current.checked ? true : false,
          duration: selectedPackage?.duration,
          package_id: selectedPackage?.id,
          coupon_code: couponCode,
          coupon_code_id: couponCodeId,
          discount: discount,
          discount_amount: discountAmount,
          original_amount: originalAmount,
          subscription_type: selectedSubscriptionType,
        };
      }
      const isIndividual =
        [1, 2, 3].includes(selectedPackage.id) ||
        selectedPackage.package_type === "customer_specific_personal";
      const endpoint = isIndividual
        ? "individualUserProcessPayment"
        : "processPayment";
      console.log("[CheckoutForm] package_type:", selectedPackage.package_type, "id:", selectedPackage.id, "→", endpoint);
      let { status, message } = await post(
        `${TRANSACTION}/${endpoint}`,
        paymentObj,
        Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
      );

      if (!status) {
        setIsLoading(false);
        showToast(false, message);
        return;
      }

      let paymentMessage = message;
      if (status) {
        let { status, message, data } = await get(
          GET_USER,
          Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
        );

        if (status) {
          if (Object.keys(data).length > 0) {
            data.token = loggedUser.token;
            setLoggedUser(data);
            userActions(data);
            setIsLoading(false);
            setError(null);
            handleCloseModal(true);
            showToast(true, paymentMessage);
            if (personalAccount) {
              navigate("/");
            } else {
              setIsOwnerPackageActive(true);
              // Parent handleCloseModal(true) will refresh subscription data
            }
          }
        } else {
          showToast(status, message);
          navigate("/");
        }
      }
    } catch (error) {
      setError(error.message);
      setIsLoading(false);
      showToast(false, error.message);
      return;
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit} style={{ width: "-webkit-fill-available" }}>
        {selectedPackage.id !== 1 ? (
          <>
            {couponData?.package_price_after_discount !== 0 ? (
              <div
                style={{
                  border: "2px solid #DAE9F4",
                  padding: "10px",
                  borderRadius: "50px",
                  background: "#fafafa",
                }}
                className="cardElementWrapper"
              >
                <CardElement id="card-element" options={cardElementOptions} />
              </div>
            ) : (
              ""
            )}
            <div className="autoCheckbox text-start mt-3 form-group mb-0">
              <Form.Check
                type="checkbox"
                id={`default-checkbox`}
                label={`Auto Subscription`}
                // onChange={handleAutoCheck}
                ref={checkbox}
              />
            </div>
          </>
        ) : (
          <div>
            <div className="autoCheckbox">
              <Form.Check
                className="my-custom-check"
                type="checkbox"
                id={`downgrade-checkbox`}
                label={`Yes, I am sure to downgrade my package.`}
                ref={checkbox}
                style={{ textAlign: "justify", fontSize: "13px" }}
                // onChange={() => setIsChecked(!isChecked)}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setIsChecked(checked);

                  if (checked && selectedPackage?.id === 1) {
                    trackEvent("Downgrade Intent Confirmed", {
                      package_id: selectedPackage.id,
                      package_name: selectedPackage.package_name,
                      price: selectedPackage.price,
                      reason: "User confirmed downgrade to free package",
                      platform: "web",
                    });
                  }
                }}
              />
            </div>
          </div>
        )}
        <div>
          {error && <p className="errorText">{error}</p>}
          {/* {couponData?.package_price_after_discount !== 0 ? (
            <div className="text-center mt-4">
              <button
                type="submit"
                disabled={!stripe || isLoading}
                className={classes.payBtn}
              >
                {isLoading ? "Processing..." : "Pay"}
              </button>
            </div>
          ) : (
            <div className="text-center mt-4">
              <button
                type="submit"
                className={classes.payBtn}
                disabled={!isChecked}
              >
                Submit
              </button>
            </div>
          )} */}
          <div
            className="mobileViewWrapper d-block text-end"
            style={{ marginTop: "50px" }}
          >
            <Button
              variant="outline-primary"
              onClick={handleCloseModal}
              className="mx-3"
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              type="submit"
              disabled={
                !stripe || isLoading || (selectedPackage.id === 1 && !isChecked)
              }
              className="payBtn"
            >
              {selectedPackage.id === 1 ||
              couponData?.package_price_after_discount == 0
                ? "Yes, Downgrade"
                : isLoading
                ? "Processing..."
                : "Pay"}
            </Button>
          </div>
        </div>
      </form>
    </>
  );
};
export default CheckoutForm;
